import { render, staticRenderFns } from "./OSK.vue?vue&type=template&id=4bd6e32e&scoped=true"
import script from "./OSK.vue?vue&type=script&lang=js"
export * from "./OSK.vue?vue&type=script&lang=js"
import style0 from "./OSK.vue?vue&type=style&index=0&id=4bd6e32e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6e32e",
  null
  
)

export default component.exports